import InvoiceService from "@/store/services/invoice.service.js"

export default {
  data () {
    return {
    }
  },
  computed:{

  },
  methods: {
    getUrl (url, item_id = null) {
      let target_url = null
      if (item_id) {
        target_url = window.Urls[url](item_id)
      } else {
        target_url = window.Urls[url]()
      }
      return target_url
    },
    markAsSent () {
      console.log('markAsSent -> mark as sent invoice')
      this.showAdjustModal = true
      this.markedAsSent = true
    },
    creditInvoice (invoice_id) {
      InvoiceService.createCredit(invoice_id).then((response) => {
        // this.$router.push({ name: 'InvoiceEdit', params: { invoiceId: response.data.id } })
        window.location.href = window.Urls["invoices_edit_invoice"](response.data.id)
      })
    },
    // TODO remove this when full release
    copyInvoice (selected) {
      if (!this.currentCompany.is_premium) {
        this.$store.commit('togglePremiumModal', 'web_invoices_copy')
      } else {
        if (selected.customer_id) {
          // TODO backend: project_id?
          const options = { recipient_customer: selected.customer_id }
          if (selected.project_id) {
            options.project = selected.project_id
          }
          InvoiceService.copyInvoice(this.invoiceToCopy.id, options).then((response) => {
            this.invoiceToCopy = null
            window.location.href = window.Urls["invoices_edit_invoice"](response.data.id)
          })
        }
      }
    },
    downloadDocument (item) {
      location.href = window.Urls['documents:download'](item.id)
    },
  }
}